module.exports = __webpack_public_path__ + "static/media/PB_G_07.4ba77e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_07.png
// module id = 220
// module chunks = 0